import { getConferenceState } from './../base/conference/functions';
import { createSlice } from "@reduxjs/toolkit";
import ReducerRegistry from "../base/redux/ReducerRegistry";
import { NOTIFICATION_TIMEOUT_TYPE, showNotification } from '../notifications';
export const createRoomCascadeSession = (destinationRoomId, nearSiteName, farSiteName, destinationPassword = '') => (dispatch, getState) => {
    const state = getState();
    const { conference } = getConferenceState(state);
    const instance = conference?.createRoomCascadeSession(destinationRoomId, destinationPassword, nearSiteName, farSiteName);
    dispatch(addRoomCascadeSession({
        roomId: destinationRoomId,
        password: destinationPassword,
        nearSiteName,
        farSiteName,
        instance
    }));
};
export const createAndStartRoomCascadeSession = (session) => (dispatch, getState) => {
    const state = getState();
    const { conference } = getConferenceState(state);
    const instance = conference?.createRoomCascadeSession(session.roomId, session.password, session.nearSiteName, session.farSiteName);
    if (instance instanceof Error) {
        dispatch(showNotification({
            titleKey: `roomCascade.notification.info.moderator`,
            descriptionKey: 'roomCascade.notification.info.moderator-content'
        }, NOTIFICATION_TIMEOUT_TYPE.LONG));
    }
    else {
        instance?.start();
        dispatch(addRoomCascadeSession({ ...session, instance }));
    }
};
const initialState = {
    sessions: {},
    tmpSession: undefined,
    usedConnections: 0,
    limitConnections: 0,
    cascadeParticipants: []
};
// Slice for file upload moderation
const roomCascade = createSlice({
    name: 'features/room-cascade',
    initialState,
    reducers: {
        addRoomCascadeSession: (state, action) => {
            const session = action.payload;
            if (!state.sessions) {
                state.sessions = {};
            }
            state.sessions[session.roomId] = session;
        },
        removeRoomCascadeSession: (state, action) => {
            const session = action.payload;
            if (!state.sessions) {
                state.sessions = {};
            }
            if (typeof session === 'string') {
                delete state.sessions[session];
            }
            else {
                delete state.sessions[session.roomId];
            }
        },
        updateRoomCascadeSession: (state, action) => {
            const info = action.payload;
            if (!state.sessions) {
                state.sessions = {};
            }
            state.sessions[info.roomId] = {
                ...state.sessions[info.roomId],
                ...info
            };
        },
        setUsedConnections: (state, action) => {
            const connections = action.payload;
            state.usedConnections = connections;
        },
        setLimitConnections: (state, action) => {
            const connections = action.payload;
            state.limitConnections = connections;
        },
        setTmpSession: (state, action) => {
            state.tmpSession = action.payload;
        },
        addCascadeParticipant: (state, action) => {
            const participant = action.payload;
            state.cascadeParticipants.push(participant);
        },
        removeCascadeParticipant: (state, action) => {
            const participantId = action.payload;
            state.cascadeParticipants = state.cascadeParticipants.filter(p => p.participantId !== participantId);
        },
        updateCascadeParticipant: (state, action) => {
            const roomId = action.payload;
            state.cascadeParticipants = state.cascadeParticipants.map(p => {
                if (p.roomId === roomId || p.participantId === roomId)
                    return { ...p, onReady: true };
                return p;
            });
        }
    }
});
ReducerRegistry.register('features/room-cascade', roomCascade.reducer);
export const { addRoomCascadeSession, removeRoomCascadeSession, setUsedConnections, setLimitConnections, updateRoomCascadeSession, setTmpSession, addCascadeParticipant, removeCascadeParticipant, updateCascadeParticipant } = roomCascade.actions;
export default roomCascade.reducer;
